import { CountryCode } from 'libphonenumber-js';

export interface IRawPhoneNumberSettings {
  code: string;
  alpha2_country_code: CountryCode;
}
